import LoginPage from '../pages/LoginPage/LoginPage';
import { useSelector } from 'react-redux';

export const PrivateContent = ({ children }) => {
    const { logined } = useSelector((state) => ({
        logined: state.auth.logined,
    }));
    if (logined) return children;
    return <LoginPage />;
};
